const map = {
	"./angiang.png": 4941,
	"./baclieu.png": 3679,
	"./bentre.png": 4222,
	"./binhdinh.png": 2142,
	"./binhduong.png": 2860,
	"./binhphuoc.png": 6166,
	"./binhthuan.png": 2701,
	"./camau.png": 8873,
	"./cantho.png": 13,
	"./daklak.png": 7072,
	"./daknong.png": 2826,
	"./dalat.png": 8722,
	"./danang.png": 8875,
	"./dongnai.png": 4328,
	"./dongthap.png": 5201,
	"./gialai.png": 785,
	"./haugiang.png": 5266,
	"./hue.png": 4128,
	"./khanhhoa.png": 7448,
	"./kiengiang.png": 4381,
	"./komtum.png": 5095,
	"./longan.png": 2595,
	"./mienbac.png": 4281,
	"./ninhthuan.png": 6177,
	"./phuyen.png": 2839,
	"./quangbinh.png": 5333,
	"./quangnam.png": 5254,
	"./quangngai.png": 8915,
	"./quangtri.png": 3929,
	"./soctrang.png": 5525,
	"./tayninh.png": 2894,
	"./tiengiang.png": 9938,
	"./tphcm.png": 8342,
	"./travinh.png": 3604,
	"./vinhlong.png": 6547,
	"./vungtau.png": 3106
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8623;